"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = require("react");

var _default = (0, _react.createContext)();

exports.default = _default;
//# sourceMappingURL=FacebookContext.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-facebook/lib/FacebookContext.js
// module id = 146
// module chunks = 0